module.exports = __webpack_public_path__ + "img/245.d24d1ce3.png";